import React from 'react';
import FBRAPIChecker from '../components/FBRAPIChecker';

const FBRAPICheckerPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <FBRAPIChecker />
    </div>
  );
};

export default FBRAPICheckerPage;
